import { IGetResourceDetailParamsType } from "../types"

const resourceBaseUrl = "/resource"

export const ResourceEndpointConst={
    AddEditResourceUrl: `${resourceBaseUrl}`,
    GetResourceListUrl: `${resourceBaseUrl}/list`,
    AddResourceAllocationUrl: `${resourceBaseUrl}/allocation`,
    GetAllocatedResourceListUrl: `${resourceBaseUrl}/allocated/list`,

}

export const getResourceUserHistory = (params: IGetResourceDetailParamsType) => {
    return `${resourceBaseUrl}/${params.resourceId}/history`
}

export const getResourceById = (params: IGetResourceDetailParamsType) => {
    return `${resourceBaseUrl}/${params.resourceId}`
}

export const deleteResource = (resourceId: number) => {
    return `${resourceBaseUrl}/${resourceId}`
}

